import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/store'
import Configuration from '@/utils/configuration'

const protocol = Configuration.value('backendProtocol');
const host = Configuration.value('backendHost');

axios.defaults.baseURL = protocol + '://' + host
axios.interceptors.request.use((config) => {
  config.headers.common['Content-Type'] = 'application/json'

  const jwtToken = store.getters['auth/jwtToken'];
  if (jwtToken) {
    // Set JWT token before request is sent
    config.headers.common['X-Access-Token'] = jwtToken
  }

  return config
}, (error) => {
  // Do something with request error
  return Promise.reject(error)
})

Vue.use(VueAxios, axios)
